import React from "react";
import DashboardChart from "./DashboardChart";
import { VerticalData } from "./types";

const ChartBox = ({ data }: { data: VerticalData[] }) => {
  if (!data?.length) return null;

  return (
    <div className="chart-card">
      <h4 className="chart-title">
        {data.length === 1 ? data[0].vertical_name : "Vertical Comparison"}
      </h4>

      <DashboardChart data={data} />
    </div>
  );
};

export default ChartBox;
